import React, { useState } from 'react';
import { Modal, Form, Input, Upload, message, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { api, uploadCreatorPicToS3 } from '../../services/api';

const CreatorModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('You can only upload image files!');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must be smaller than 2MB!');
      return false;
    }
    return false; // Prevent auto upload
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      let picS3key = null;
      
      // Upload file to S3 first if present
      if (fileList.length > 0 && fileList[0].originFileObj) {
        setUploading(true);
        try {
          picS3key = await uploadCreatorPicToS3(fileList[0].originFileObj);
          console.log('Creator pic uploaded, s3Key:', picS3key);
        } catch (error) {
          message.error('Failed to upload profile picture');
          setLoading(false);
          setUploading(false);
          return;
        }
        setUploading(false);
      }

      // Send JSON payload with S3 key
      const payload = {
        name: values.name,
        jobTitle: values.jobTitle || null,
        picS3key: picS3key,
      };

      console.log('Creating creator with payload:', payload);
      const response = await api.createCreator(payload);

      if (response.data.success) {
        message.success('Creator created successfully!');
        form.resetFields();
        setFileList([]);
        onSuccess();
        onCancel();
      }
    } catch (error) {
      console.error('Error creating creator:', error);
      message.error(error.response?.data?.message || 'Failed to create creator');
    } finally {
      setLoading(false);
      setUploading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setFileList([]);
    onCancel();
  };

  return (
    <Modal
      title="Add New Creator"
      open={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading || uploading}
      okText="Create"
      cancelText="Cancel"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="name"
          label="Creator Name"
          rules={[{ required: true, message: 'Please enter creator name' }]}
        >
          <Input placeholder="Enter creator name" />
        </Form.Item>

        <Form.Item
          name="jobTitle"
          label="Job Title"
        >
          <Input placeholder="Enter job title (optional)" />
        </Form.Item>

        <Form.Item
          label="Profile Picture"
        >
          <Upload
            listType="picture"
            fileList={fileList}
            onChange={handleFileChange}
            beforeUpload={beforeUpload}
            maxCount={1}
            accept="image/*"
          >
            <Button icon={<UploadOutlined />} loading={uploading}>
              Upload Picture
            </Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreatorModal;

